import React, {useState, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography, AccordionActions} from '@material-ui/core';
import {PrimaryCapaModal} from './Modals/';
import {StyledTextField} from 'components/';
import {ExpandMore} from '@material-ui/icons';
import {useHistory} from 'react-router-dom';

const CapaPanel = ({selectedRootCause}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const history = useHistory();

  const navigateToCapa = (e, capa)=> {
    e.stopPropagation();
    history.push(`/corrective-actions/${capa.Ref}`);
  };

  return <Accordion defaultExpanded={false}>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography>Primary CAPA&apos;s</Typography>
    </AccordionSummary>
    <AccordionDetails>

      {selectedRootCause.PrimaryCapas.length ? (
        <Grid container spacing={2}>
          {selectedRootCause.PrimaryCapas.map(capa => (
            <Grid container spacing={2} key={capa.Ref} style={{margin: '8px', border: '1px solid lightgrey'}}>

              <Fragment>
                <Grid item xs={6} sm={3}>
                  <StyledTextField value={capa.Number} label='CAPA Number' isLink onClick={(e) => navigateToCapa(e, capa)} />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <StyledTextField value={capa.Location} label='Location' />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <StyledTextField value={capa.Assignees} label='Assignees' />
                </Grid>
                <Grid item xs={12}>
                  <StyledTextField value={capa.Observation} label='Observation' />
                </Grid>
              </Fragment>

            </Grid>
          ))}
        </Grid>) :
        <Typography>There are no Primary CAPA&apos;s</Typography>}
    </AccordionDetails>
    <AccordionActions>
      {selectedRootCause.Status !== 'Completed' ? <Button variant='outlined' onClick={() => setModalOpen(true)} color='primary'>Add Primary CAPA&apos;s</Button> : null}
    </AccordionActions>
    {modalOpen && <PrimaryCapaModal selectedRootCause={selectedRootCause} close={() => setModalOpen(false)} />}
  </Accordion>;
};

CapaPanel.propTypes = {
  selectedRootCause: PropTypes.object.isRequired,
};

export default CapaPanel;
